export default __webpack_public_path__ + "static/media/boxCleverMb2.c45ae769.png";